import React from 'react';
import { RefreshCw, Lock } from 'lucide-react';
export function LivePreview() {
  return <div className="flex flex-col h-full bg-gray-50 border-b border-gray-200" data-id="element-82">
      {/* Browser Chrome */}
      <div className="flex items-center px-3 py-2 bg-white border-b border-gray-200 space-x-2" data-id="element-83">
        <div className="flex space-x-1.5" data-id="element-84">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400/50" data-id="element-85"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-amber-400/50" data-id="element-86"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-green-400/50" data-id="element-87"></div>
        </div>
        <div className="flex-1 flex items-center bg-gray-100 rounded-md px-2 py-1 text-xs text-gray-500 mx-2" data-id="element-88">
          <Lock className="h-3 w-3 mr-1.5 text-gray-400" data-id="element-89" />
          localhost:3000
        </div>
        <button className="p-1 hover:bg-gray-100 rounded" data-id="element-90">
          <RefreshCw className="h-3.5 w-3.5 text-gray-400" data-id="element-91" />
        </button>
      </div>

      {/* Preview Content */}
      <div className="flex-1 overflow-auto p-4 flex items-center justify-center bg-white" data-id="element-92">
        <div className="w-full max-w-sm border border-gray-100 shadow-sm rounded-lg overflow-hidden" data-id="element-93">
          {/* Mock Landing Page */}
          <div className="bg-blue-600 h-32 flex flex-col items-center justify-center text-white p-4 text-center" data-id="element-94">
            <div className="h-2 w-16 bg-blue-400 rounded mb-2" data-id="element-95"></div>
            <div className="h-4 w-32 bg-white rounded mb-2" data-id="element-96"></div>
            <div className="h-2 w-24 bg-blue-400 rounded" data-id="element-97"></div>
          </div>
          <div className="p-4 space-y-3 bg-white" data-id="element-98">
            <div className="flex space-x-3" data-id="element-99">
              <div className="flex-1 h-20 bg-gray-100 rounded" data-id="element-100"></div>
              <div className="flex-1 h-20 bg-gray-100 rounded" data-id="element-101"></div>
              <div className="flex-1 h-20 bg-gray-100 rounded" data-id="element-102"></div>
            </div>
            <div className="h-2 w-full bg-gray-100 rounded" data-id="element-103"></div>
            <div className="h-2 w-2/3 bg-gray-100 rounded" data-id="element-104"></div>

            {/* Contact Form Placeholder (to show what we're building) */}
            <div className="mt-4 pt-4 border-t border-dashed border-gray-200" data-id="element-105">
              <div className="h-3 w-20 bg-gray-200 rounded mb-3" data-id="element-106"></div>
              <div className="space-y-2" data-id="element-107">
                <div className="h-8 w-full border border-gray-200 rounded bg-gray-50" data-id="element-108"></div>
                <div className="h-8 w-full border border-gray-200 rounded bg-gray-50" data-id="element-109"></div>
                <div className="h-16 w-full border border-gray-200 rounded bg-gray-50" data-id="element-110"></div>
                <div className="h-8 w-24 bg-blue-600 rounded opacity-50" data-id="element-111"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}